import styled from "styled-components"
import Icon from "../../../components/Icon/icon"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const EventImg = styled.div`
  &::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const EventDate = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
  margin-bottom: 0;
`
const EventTaxo = styled.div`
  & > a {
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
const EventTitle = styled.h1`
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const EventPlaceIcon = styled(Icon)`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const EventPlaceTitle = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const EventFooterContainer = styled.div`
  color: ${(props) => props.theme.a_color_gradients.a_medium};
`
const EventItemRecurrence = styled.p`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export {
  AdditionalInfos,
  EventImg,
  EventDate,
  EventTaxo,
  EventTitle,
  EventPlaceIcon,
  EventPlaceTitle,
  EventFooterContainer,
  EventItemRecurrence,
}
